import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const NoteIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 255 255" {...rest} __css={styles}>
      <desc id="svgdescVision">note</desc>
      <circle className="accent" cx="127.5" cy="127.5" r="127.5" />
      <path
        className="background"
        d="M128,0a127.5,127.5,0,1,0,127.5,127.5A127.5,127.5,0,0,0,128,0Z"
        style={{
          fill: variant === 'darkIconNoBackground' ? 'white' : undefined,
        }}
      />
      <path
        className="accent"
        d="M95.68,48.81,62.27,82.22v124h128l.09-11.72a7.87,7.87,0,0,1-2.52-.56,53.86,53.86,0,0,1-20.25-14,59.29,59.29,0,0,1-12.25-22.18A84.17,84.17,0,0,1,152,127.16a6.1,6.1,0,0,1,4.91-5.45c6.61-1.27,22.72-5,29.61-12.08a6.07,6.07,0,0,1,4.36-1.83h.21l.46-59ZM98,55.59V85.92H68.38Zm45.44,119.52h-59v-4.9h59Zm0-21.33h-59v-4.9h59Zm0-21.32h-59v-4.9h59Zm20.07-21.32h-79v-4.9h79Zm0-21.33H115.38v-4.9H163.5Zm0-21.32H115.38v-4.9H163.5Z"
      />
      <path
        className="accent"
        d="M191.91,188.82a5.58,5.58,0,0,1-2-.4c-14.12-5.69-23.73-16.4-28.55-31.82a74.57,74.57,0,0,1-3-27.16,3.75,3.75,0,0,1,3-3.35c17.92-3.45,25.2-8.69,27.94-11.51a3.72,3.72,0,0,1,5.34,0c2.75,2.82,10,8.06,27.94,11.51a3.75,3.75,0,0,1,3,3.34h0a74.48,74.48,0,0,1-3,27.16C217.7,172,208.09,182.73,194,188.42A5.5,5.5,0,0,1,191.91,188.82ZM162.31,130a70.75,70.75,0,0,0,2.87,25.36c4.44,14.21,13.26,24.05,26.2,29.27a1.52,1.52,0,0,0,1.07,0c12.94-5.22,21.75-15.06,26.2-29.27A70.43,70.43,0,0,0,221.51,130c-8.11-1.58-22.42-5.25-29.6-12.38C184.73,124.78,170.43,128.45,162.31,130Z"
      />
      <path
        className="accent"
        d="M175.12,145.36H188V132.51h8.52v12.85h12.85v8.52H196.49v12.85H188V153.88H175.12Z"
      />
    </Icon>
  );
};

export default NoteIcon;
